import { render, staticRenderFns } from "./work-permit-history.component.vue?vue&type=template&id=0835dd98"
import script from "./work-permit-history.component.ts?vue&type=script&lang=ts&external"
export * from "./work-permit-history.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports